import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-64" data-mp="1gd7h4a4s9d6j">
      <div className="mx-auto w-full max-w-2xl" data-id="element-65" data-mp="1gaurdass9yix">
        <Reveal data-id="element-66" data-mp="2dzemhm8wv9jy">
          <h2 className="text-center text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-67" data-mp="2dzxti7x0wdj7">
            Vanliga frågor
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-68" data-mp="241gy8yr1xcrc">
          <div className="mt-12 overflow-hidden rounded-2xl border border-sand" data-id="element-69" data-mp="240p3tr96xl2n">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={faq.question} className={index > 0 ? 'border-t border-sand' : ''} data-id="element-70" data-mp="soo8tulqh0eg" data-mpi={index}>
                  <h3 data-id="element-71" data-mp="pi7hkfvx0ume">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-cream px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-sand/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-level-blue" data-id="element-72" data-mp="pho7flcibaix">
                      <span className="text-[15px] font-extrabold text-navy" data-id="element-73" data-mp="6pdb6accyats">
                        {faq.question}
                      </span>
                      {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-level-blue" aria-hidden="true" data-id="element-74" data-mp="3t07vebo5ju7x" /> : <PlusIcon className="h-4 w-4 shrink-0 text-level-blue" aria-hidden="true" data-id="element-75" data-mp="3jyrtytfbf2fu" />}
                    </button>
                  </h3>

                  <AnimatePresence initial={false} data-id="element-76" data-mp="1ppmd90b4iqde">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden bg-white" data-id="element-77" data-mp="1kqrwe3wpvbvx">
                        <p className={`px-6 pb-6 pt-5 text-sm leading-relaxed ${faq.isPlaceholder ? 'font-mono text-xs uppercase text-level-red' : 'text-muted'}`} data-id="element-78" data-mp="28et08ziya450">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </Reveal>
      </div>
    </section>;
}